module.exports = __webpack_public_path__ + "fonts/araboto-black-webfont.f10a7f69.woff2";